module.exports = __webpack_public_path__ + "media/images/emblems/Bannwil-coat_of_arms-08a1bf1bca257a43f6379fd20d7ac32f.svg";